import React, { Component, Fragment } from 'react';
import { noop } from 'lodash';
import { Trans } from 'react-i18next';
import { FormikProps, FormikValues } from 'formik';
import { Button } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { S3ObjectInput } from 'api';
import { AspectRatios } from 'types/app';
import { CustomSVG, IUploader, UploadDialog, Uploader, UploadInput } from 'components';

interface IPropsEnhanced extends WithStyles<typeof styles> {
  formikProps: FormikProps<FormikValues>;
  onSave?: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 0,
    },
  });

class PhotoUpload extends Component<IPropsEnhanced> {
  static defaultProps = {
    onSave: noop,
  };

  handleSave = (photo: S3ObjectInput) => {
    const { formikProps, onSave } = this.props;
    const { setFieldValue } = formikProps;

    setFieldValue('content_object.photos', [photo]);
    onSave();
  };

  render() {
    const { classes } = this.props;

    return (
      <Uploader>
        {(uploaderProps: IUploader) => (
          <Fragment>
            <UploadInput onUpload={uploaderProps.onUpload}>
              <Button
                size="small"
                component="span"
                className={classes.button}
                startIcon={<CustomSVG name="camera" />}>
                <Trans i18nKey="posting:photoUpload" />
              </Button>
            </UploadInput>
            <UploadDialog
              i18nKey="posting:photo"
              aspectRatio={AspectRatios.none}
              onSave={this.handleSave}
              {...uploaderProps}
            />
          </Fragment>
        )}
      </Uploader>
    );
  }
}

export default withStyles(styles)(PhotoUpload);
